import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import {
    SuperAdminOwnerApartmentDto,
    SuperAdminOwnerListItemDto,
} from '@/features/superAdmin/features/data/types/superAdmin-data.types';
import {
    formatBoolean,
    formatNavValue,
} from '@/features/superAdmin/features/data/shared/utils/superAdminDataFormatters';
import { getOwnerStatusLabel } from '@/features/superAdmin/features/data/owners/utils/superAdminOwnerEnumLabels';

export const useSuperAdminOwnersPageColumns = () => {
    const { t } = useTranslation();

    const columns: ColumnDef<SuperAdminOwnerListItemDto>[] = [
        { accessorKey: 'id', header: t('superAdmin.data.columns.id') },
        {
            accessorKey: 'tenantName',
            header: t('superAdmin.data.columns.tenant'),
            cell: ({ row }) => formatNavValue(row.original.tenantId, row.original.tenantName),
        },
        { accessorKey: 'name', header: t('superAdmin.data.owners.columns.name') },
        { accessorKey: 'email', header: t('superAdmin.data.owners.columns.email') },
        { accessorKey: 'phoneNumber', header: t('superAdmin.data.owners.columns.phoneNumber') },
        { accessorKey: 'tin', header: t('superAdmin.data.owners.columns.tin') },
        { accessorKey: 'language', header: t('superAdmin.data.owners.columns.language') },
        {
            accessorKey: 'status',
            header: t('superAdmin.data.columns.status'),
            cell: ({ row }) => getOwnerStatusLabel(row.original.status, t),
        },
        { accessorKey: 'userId', header: t('superAdmin.data.owners.columns.userId') },
        { accessorKey: 'personalId', header: t('superAdmin.data.owners.columns.personalId') },
        {
            accessorKey: 'deletionMark',
            header: t('superAdmin.data.columns.deletionMark'),
            cell: ({ row }) => formatBoolean(row.original.deletionMark),
        },
        { accessorKey: 'externalId', header: t('superAdmin.data.columns.externalId') },
    ];

    return columns;
};

export const ownerApartmentNestedColumns: ColumnDef<SuperAdminOwnerApartmentDto>[] = [
    { accessorKey: 'id', header: 'Id' },
    { accessorKey: 'name', header: 'Name' },
    { accessorKey: 'externalId', header: 'ExternalId' },
    { accessorKey: 'hotelName', header: 'Hotel' },
    {
        accessorKey: 'isVirtual',
        header: 'IsVirtual',
        cell: ({ row }) => formatBoolean(row.original.isVirtual),
    },
    {
        accessorKey: 'deletionMark',
        header: 'DeletionMark',
        cell: ({ row }) => formatBoolean(row.original.deletionMark),
    },
];
